import React, { PropsWithChildren, useEffect, useState } from 'react';

import * as SentryInitializer from '@/infrastructure/sentry/utils';

const withSentryInitialization = <P extends PropsWithChildren<unknown>>(Component: React.ComponentType<P>) => (
  props: P,
): JSX.Element => {
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    if (!initialized) {
      try {
        SentryInitializer.init();
      } finally {
        setInitialized(true);
      }
    }
  }, [initialized]);
  return initialized ? <Component {...props} /> : <></>;
};

export default withSentryInitialization;
